import { render, staticRenderFns } from "./CaseDetail.vue?vue&type=template&id=9d643a0a&scoped=true"
import script from "./CaseDetail.vue?vue&type=script&lang=js"
export * from "./CaseDetail.vue?vue&type=script&lang=js"
import style0 from "./CaseDetail.vue?vue&type=style&index=0&id=9d643a0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d643a0a",
  null
  
)

export default component.exports